<nz-page-header nzTitle="Pending Benefit Payment List"></nz-page-header>

<div class="row mt-3">
	<div class="col">
		<nz-card nzTitle="Generate Payment Letter">
			<div class="row align-items-end g-3">
				<div class="col-auto">
					<nz-form-item>
						<nz-form-label nzFor="ticketRef">Ticket Reference</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a ticket reference">
							<nz-input-group nzPrefixIcon="tag">
								<input nz-input id="ticketRef" name="ticketRef" [(ngModel)]="ticketReference"
									placeholder="Enter ticket ID or reference" [disabled]="submitting"
									style="width: 280px" />
							</nz-input-group>
						</nz-form-control>
					</nz-form-item>
				</div>
				<div class="col-auto mb-3">
					<button nz-button nzType="primary" [nzLoading]="submitting"
						[disabled]="!ticketReference || submitting" (click)="onSubmitPaymentLetter()">
						<span nz-icon nzType="send" nzTheme="outline"></span>
						Email Payment Letter
					</button>
				</div>
			</div>
		</nz-card>
	</div>
</div>

<div class="row mt-5" *ngIf="data">
	<div class="col">
		<button nz-button nzType="primary" [nzLoading]="submitting" [disabled]="data.list.length == 0" (click)="onSubmitPaymentFile()">
			<span nz-icon nzType="send" nzTheme="outline"></span>
			Generate Bank Payment File
		</button>
	</div>
</div>
<div class="row mt-1" *ngIf="data">
	<div class="col">
		<app-table [data]="data" [headerClass]="'table-info'" [columns]="columnRef" [loading]="loading"
			[disablePaging]="false" (onUpdateRequired)="doFetchUploads($event)">
			<ng-template #beneficiaryRef let-row="row">
				<td *ngIf="row.beneficiaryPerson">{{row.beneficiaryPerson.name}} {{row.beneficiaryPerson.surname}}</td>
				<td *ngIf="row.beneficiaryGeneric">{{row.beneficiaryGeneric.name}}</td>
			</ng-template>
			<ng-template #benefitPaymentAmountRef let-row="row">
				<td>{{row.benefitPaymentAmount | currency:'ZAR':'symbol-narrow'}}</td>
			</ng-template>
		</app-table>
	</div>
</div>
